var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarthquakeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -8.33333333e-05 30.0007917 -8.33333333e-05 30.0007917 26.3985003 0 26.3985003"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Earthquake-Coverage",
    transform: "translate(-49.000000, -253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(49.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-earthquake-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.16666667e-05,7.1435 L-4.16666667e-05,25.5651667 C-4.16666667e-05,26.0251667 0.372458333,26.3980833 0.832458333,26.3985003 L0.833291667,26.3985003 L10.000375,26.3985003 L13.3337083,21.3985 L11.6670417,16.3985 L18.3337083,9.73183333 L16.6670417,16.3985 L20.000375,19.7318333 L18.3337083,26.3985003 L29.1674583,26.3985003 C29.6270417,26.3989167 30.000375,26.0264167 30.0007917,25.566 L30.0007917,25.5651667 L30.0007917,7.14266667 L15.000375,-0.00025 L-4.16666667e-05,7.1435 Z",
    id: "Fill-1",
    fill: "#FBFBFD",
    mask: "url(#mask-earthquake-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquakeIcon);
export default __webpack_public_path__ + "static/media/earthquake_icon.0dd3870d.svg";
export { ForwardRef as ReactComponent };